<template>
    <div class="type-list">
        <p
            v-for="(item, index) in data"
            class="type"
            :class="{'active': `${item.type}` === `${newSelect}`}"
            :key="index"
            @click="handleClick(item)"
        >
            {{item.name}}
        </p>
    </div>
</template>

<script>
    export default {
        name: "type-list",
        props: {
            data: Array,
            select: [String, Number]
        },
        watch: {
          select(vl){this.newSelect = vl},
          newSelect(vl){this.$emit('update:select', vl)}
        },
        data(){
            return {
                newSelect: this.select
            }
        },
        methods: {
            handleClick(item){
                console.log(item)
                // this.newSelect = item.id
                // this.$emit('onTypeList', item)
            }
        }
    }
</script>

<style lang="scss" scoped>
.type-list{
    width: 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #f1f1f1;
    background-color: #303133;
    padding-top: 20px;
    flex-shrink: 0;

    .type{
        width: 100%;
        line-height: 50px !important;
        height: 50px;
        text-align: center;
        font-size: 16px;
        color:rgba(153,153,153,1);
        transition: font .2s linear;

        &.active{
            font-size: 16px;
            color: white;
            background-color: #e7622e;
        }
    }
}
</style>
